/**
 * The editor owns Konva nodes, while export controls live above the canvas.
 * Registering the active canvas refresher lets export await a final metadata
 * refresh without coupling export code to a particular editor component.
 */
type FlowchartTextLayoutRefresher = () => Promise<void>;

let activeRefresher: FlowchartTextLayoutRefresher | null = null;

export const registerFlowchartTextLayoutRefresher = (refresher: FlowchartTextLayoutRefresher): (() => void) => {
  activeRefresher = refresher;
  return () => {
    if (activeRefresher === refresher) activeRefresher = null;
  };
};

export const flushFlowchartTextLayouts = async (): Promise<void> => {
  await activeRefresher?.();
};
